<template>
    <div>
        <HlistVideoItem :data="data" />
    </div>
</template>

<script>
import HlistVideoItem from "../hListItems/VideoItem";
export default {
    name: "VideoItem",
    props: ["data"],
    components: {
        HlistVideoItem
    }
};
</script>
